import MaybachLink from './MaybachLink'

export default MaybachLink
